module.exports = "pegasus_template/assets/blocks/tile-layout-09.png";